import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFIssuesSupportWidget = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H18C19.1046 18 20 17.1046 20 16V6C20 4.89543 19.1046 4 18 4H4ZM18.5 6.5C18.5 7.05228 18.0523 7.5 17.5 7.5C16.9477 7.5 16.5 7.05228 16.5 6.5C16.5 5.94772 16.9477 5.5 17.5 5.5C18.0523 5.5 18.5 5.94772 18.5 6.5ZM5 9.5C5 9.22386 5.22386 9 5.5 9H13.5C13.7761 9 14 9.22386 14 9.5C14 9.77614 13.7761 10 13.5 10H5.5C5.22386 10 5 9.77614 5 9.5ZM5 13.625C5 13.0037 5.50368 12.5 6.125 12.5H8.875C9.49632 12.5 10 13.0037 10 13.625C10 14.2463 9.49632 14.75 8.875 14.75H6.125C5.50368 14.75 5 14.2463 5 13.625ZM13.125 12.5C12.5037 12.5 12 13.0037 12 13.625C12 14.2463 12.5037 14.75 13.125 14.75H15.875C16.4963 14.75 17 14.2463 17 13.625C17 13.0037 16.4963 12.5 15.875 12.5H13.125Z"
	})
});
export default SvgFIssuesSupportWidget;
